export { default as LocaleSwitch } from './LocaleSwitch';
